import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendNotification, BackendQueryNotificationsArgs } from 'src/types/backend';

const QUERY = gql`
  query Notifications($customerId: ID!, $isTabActive: Boolean) {
    notifications(customerId: $customerId, isTabActive: $isTabActive) {
      id
      title
      message
      createdAt
      link
      linkText
      type
      htmlContent
    }
  }
`;

type Variables = Pick<BackendQueryNotificationsArgs, 'customerId'>;
type Result = BackendNotification[];

export const queryNotifications = async ({ customerId }: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
      isTabActive: document.visibilityState === 'visible',
    },
  });
  return getSingleProp<Result>(result.data);
};
